import { format } from 'date-fns';

/**
 * Format current date/time for dashboard display
 */
export const formatDateTime = () => {
    const now = new Date();
    const date = format(now, 'EEEE, MMMM d, yyyy');
    const time = format(now, 'h:mm a');
    return { date, time };
};

/**
 * Get color for status light based on qualification
 */
export const getStatusColor = (qualified) => {
    return qualified ? '#48bb78' : '#f56565'; // Green or Red
};

/**
 * Get status text
 */
export const getStatusText = (qualified) => {
    return qualified ? 'Qualified' : 'Not Qualified';
};
